import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
const CollectionNote = ({ note, coll }) => {
  return (
    <div
      className='card bg-transparent col-xl-4 col-lg-6 col-md-6 col-12'
      style={{ width: " 18rem" }}
    >
      <div className='card-body'>
        {note.type && (
          <h6 className='card-subtitle mb-2 text-muted text-right'>
            {note.resourcetype}
          </h6>
        )}
        {note.name && (
          <h4 className='card-title fontcool text-center'>{note.name}</h4>
        )}
        <p>
          <span className='blue-grey-text text-lighten-2'>
            {moment(note.date.toDate()).format("MMMM Do YYYY, HH:MM")}{" "}
          </span>
        </p>
        {note.description && (
          <p className='simplefont text-center'>{note.description}</p>
        )}
        {note.author && (
          <p className='card-text slantfont text-right'>{note.author}</p>
        )}
        {note.url && (
          <Link
            to={`/${coll === "academics" ? "acad" : "extra"}/notes/${note.id}`}
          >
            {" "}
            view
          </Link>
        )}
      </div>
    </div>
  );
};

export default CollectionNote;
